import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// GROUNDING: A2UI = external Google protocol (open, JSONL streaming, catalog-based).
// EAKC has NO A2UI code. This is "how I would build it" — see
// docs/2026-05-07-eakc-strategic-synthesis.md §Part 6 + roadmap row "v2 · planned".

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 5, caption: "Soon your agent won't answer with a paragraph. It'll send back an actual interface — a form, a table, a chart — that you can click." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "Right now my missions return a wall of markdown. Useful, but dead — you can't sort it, edit it, or approve it inline." },
  { scene: "problem", fromSec: 6.2, holdSec: 5.5, caption: "And letting an LLM emit raw HTML or JavaScript is a security nightmare — that's arbitrary code in your UI." },
  { scene: "problem", fromSec: 12, holdSec: 4, caption: "So how do you let an agent build UI without letting it run code?" },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 6, caption: "There's a spectrum. Static: the agent just fills components a developer drew. Generative: it writes raw HTML and JS — powerful, but that's arbitrary code in your UI." },
  { scene: "intuition", fromSec: 6.6, holdSec: 5, caption: "The sweet spot is the middle — declarative. The agent ships a JSON description naming components your app already trusts. Safe like data, expressive like code." },
];

export const WHATIS: ScriptLine[] = [
  { scene: "whatis", fromSec: 0.4, holdSec: 6, caption: "This is A2UI — an open declarative protocol from Google. JSONL that streams UI, no executable code." },
  { scene: "whatis", fromSec: 6.6, holdSec: 5.2, caption: "Your client renders with its own React or Flutter components, from a catalogue of trusted types. AG-UI, from CopilotKit, is the transport that carries it." },
  { scene: "whatis", fromSec: 12, holdSec: 5.6, caption: "And MCP apps are the delivery layer — a sandboxed iframe by default. Anthropic uses that same mechanism even for first-party UI." },
];

export const FLOW: ScriptLine[] = [
  { scene: "flow", fromSec: 0.4, holdSec: 6, caption: "The loop: the agent streams a UI payload, the client renders it progressively, you interact." },
  { scene: "flow", fromSec: 6.6, holdSec: 6, caption: "Your clicks flow back to the agent as events, and it streams the next incremental update. Time-to-first-UI, not time-to-first-token." },
];

export const HOOKIN: ScriptLine[] = [
  { scene: "hookin", fromSec: 0.4, holdSec: 6, caption: "In EAKC there are two seams I'd wire this into first. One: mission output." },
  { scene: "hookin", fromSec: 6.6, holdSec: 6.5, caption: "My generate_artifact tool already emits PDF, DOCX and PPTX. A2UI just adds an interactive type — a sortable comparison matrix instead of a flat report." },
  { scene: "hookin", fromSec: 13.4, holdSec: 6, caption: "Two: the approve-reject surface. Today it's hand-built. The agent could generate the exact form each pending action needs." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6.5, caption: "Here's the shape I'd target — not real EAKC code yet. The agent emits component nodes, never HTML." },
  { scene: "code", fromSec: 7.2, holdSec: 6.5, caption: "A card, a table the user can sort, a button whose action routes back through my existing trust-gated gmail-send tool." },
  { scene: "code", fromSec: 14, holdSec: 6.5, caption: "The renderer maps each node to a real React component. The agent never touches the DOM." },
];

export const HONESTY: ScriptLine[] = [
  { scene: "honesty", fromSec: 0.4, holdSec: 6, caption: "Status check, June 2026: the foundation is now built — a safe component catalogue, a fail-closed validator, and a renderer, all tested." },
  { scene: "honesty", fromSec: 6.6, holdSec: 5.5, caption: "What's still roadmap is the last mile: the agent emitting A2UI and the chat rendering it end to end. Foundation shipped; emission queued." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "Generative UI is the next interface for agents — render the answer, don't just describe it. When I build it, I'll show the real diff." },
  { scene: "outro", fromSec: 6.2, holdSec: 4, caption: "Next: how my AI redacts your secrets before the model ever sees them." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
